import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        formSubmission: '=',
        selectedLanguage: '='
    },
    template: `
        <p><a class="btn discrete" ng-click="vm.show()">{{ 'quiz.Correct answers by category' | translate }}</a></p>
        <div ng-if="vm.toggle" class="w100p">
        <table class="data03 w100p" ng-if="vm.categoriesOverview">
            <thead>
            <tr>
                <th class="w100p">{{ 'quiz.Category' | translate }}</th>
                <th class="nowrap mobile-wrap">{{ 'quiz.Correct answers' | translate }}</th>
                <th class="nowrap mobile-wrap">{{ 'quiz.Questions in total' | translate }}</th>
            </tr>
            </thead>
            <tbody>
            <tr ng-repeat="category in vm.categoriesOverview">
                <td ng-if="category.activeI18n">{{ category.activeI18n.name }}</td>
                <td ng-if="!category.activeI18n">{{ 'quiz.Questions without category' | translate }}</td>
                <td class="center">{{ category.correctCount }}</td>
                <td class="center">{{ category.total }}</td>
            </tr>
            </tbody>
        </table>
`
})
export default class {
    constructor (FormSubmissionResource, $translate) {
        this.FormSubmissionResource = FormSubmissionResource;
        this.$translate = $translate;
    }

    $onInit () {
        this.toggle = false;
    }

    show () {
        this.toggle = !this.toggle;
        // if toggle is false or if categories are already loaded no further action is necessary
        if (!this.toggle || this.categoriesOverview) {
            return;
        }

        this.FormSubmissionResource.quizCategoriesOverview(
            {
                guid: this.formSubmission.guid,
                _lang: this.$translate.use()
            }
        ).$promise.then(categoriesOverview => {
            this.categoriesOverview = categoriesOverview;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/quiz/finished/overviews/index.js